<template>
  <div>
    <b-row>
      <b-col lg="12">
        <WIMMap />
      </b-col>
      <!-- <WIMRTSP /> -->
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  // BCard,
} from 'bootstrap-vue'

import WIMMap from '@/views/wim/detail/WIMMap.vue'
// import WIMRTSP from '@/views/wim/detail/WIMRTSP.vue'

export default {
  components: {
    WIMMap,
    // WIMRTSP,
    BRow,
    BCol,
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  },
}
</script>

<style>
</style>
